import { render } from "./MailVerifySignupTemplate.vue?vue&type=template&id=0efdcc5f"
import script from "./MailVerifySignupTemplate.vue?vue&type=script&lang=js"
export * from "./MailVerifySignupTemplate.vue?vue&type=script&lang=js"
script.render = render

export default script